var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "audio" } }, [
    _c("link", {
      attrs: {
        rel: "preload",
        href: "../assets/sounds/${name}.mp3",
        as: "audio",
      },
    }),
    _c("audio", {
      ref: "audiofile",
      staticStyle: { display: "none" },
      attrs: { loop: _vm.innerLoop, preload: "auto" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }